export default __webpack_public_path__ + "static/media/p1-7.2d89d7f7.png";